import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _225df9a5 = () => interopDefault(import('../pages/privacy-policy.vue' /* webpackChunkName: "pages/privacy-policy" */))
const _780dbd6a = () => interopDefault(import('../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _0b5d0398 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _554ab386 = () => interopDefault(import('../pages/pictures/index.vue' /* webpackChunkName: "pages/pictures/index" */))
const _6dc178c8 = () => interopDefault(import('../pages/user/index.vue' /* webpackChunkName: "pages/user/index" */))
const _c5894ffc = () => interopDefault(import('../pages/contact.vue' /* webpackChunkName: "pages/contact" */))
const _bfa42ee8 = () => interopDefault(import('../pages/career.vue' /* webpackChunkName: "pages/career" */))
const _f6891db6 = () => interopDefault(import('../pages/magazine/index.vue' /* webpackChunkName: "pages/magazine/index" */))
const _7d9b7872 = () => interopDefault(import('../pages/registration.vue' /* webpackChunkName: "pages/registration" */))
const _4accb922 = () => interopDefault(import('../pages/about.vue' /* webpackChunkName: "pages/about" */))
const _3f66ce0b = () => interopDefault(import('../pages/editors/index.vue' /* webpackChunkName: "pages/editors/index" */))
const _cbc2da16 = () => interopDefault(import('../pages/products/index.vue' /* webpackChunkName: "pages/products/index" */))
const _50b94d55 = () => interopDefault(import('../pages/whispers-of-wood.vue' /* webpackChunkName: "pages/whispers-of-wood" */))
const _3154f766 = () => interopDefault(import('../pages/checkout/successful-order.vue' /* webpackChunkName: "pages/checkout/successful-order" */))
const _f2fe9ea4 = () => interopDefault(import('../pages/user/favourite-products.vue' /* webpackChunkName: "pages/user/favourite-products" */))
const _085871f1 = () => interopDefault(import('../pages/checkout/shipping-and-payment-details.vue' /* webpackChunkName: "pages/checkout/shipping-and-payment-details" */))
const _56bc322b = () => interopDefault(import('../pages/checkout/cart.vue' /* webpackChunkName: "pages/checkout/cart" */))
const _bd716c2a = () => interopDefault(import('../pages/checkout/summary.vue' /* webpackChunkName: "pages/checkout/summary" */))
const _72b0df1c = () => interopDefault(import('../pages/checkout/personal-data.vue' /* webpackChunkName: "pages/checkout/personal-data" */))
const _02ea6638 = () => interopDefault(import('../pages/editors/star-map.vue' /* webpackChunkName: "pages/editors/star-map" */))
const _94b63cc0 = () => interopDefault(import('../pages/editors/topo-map.vue' /* webpackChunkName: "pages/editors/topo-map" */))
const _1dea9b3a = () => interopDefault(import('../pages/editors/wood-star-map.vue' /* webpackChunkName: "pages/editors/wood-star-map" */))
const _797f9b93 = () => interopDefault(import('../pages/editors/wood-map.vue' /* webpackChunkName: "pages/editors/wood-map" */))
const _017069d5 = () => interopDefault(import('../pages/editors/map.vue' /* webpackChunkName: "pages/editors/map" */))
const _514ed051 = () => interopDefault(import('../pages/editors/city-map.vue' /* webpackChunkName: "pages/editors/city-map" */))
const _494fe43f = () => interopDefault(import('../pages/user/forgotten-password/_id.vue' /* webpackChunkName: "pages/user/forgotten-password/_id" */))
const _0ffc069d = () => interopDefault(import('../pages/payment-failed/_id.vue' /* webpackChunkName: "pages/payment-failed/_id" */))
const _b5a6cd0c = () => interopDefault(import('../pages/payment-successful/_id.vue' /* webpackChunkName: "pages/payment-successful/_id" */))
const _2bbc6634 = () => interopDefault(import('../pages/magazine/_article.vue' /* webpackChunkName: "pages/magazine/_article" */))
const _01211dd5 = () => interopDefault(import('../pages/order-failed/_id.vue' /* webpackChunkName: "pages/order-failed/_id" */))
const _09457ab6 = () => interopDefault(import('../pages/payment-feedback/_id.vue' /* webpackChunkName: "pages/payment-feedback/_id" */))
const _11a6c403 = () => interopDefault(import('../pages/products/_category/index.vue' /* webpackChunkName: "pages/products/_category/index" */))
const _79f9569c = () => interopDefault(import('../pages/order-successful/_id.vue' /* webpackChunkName: "pages/order-successful/_id" */))
const _2204cd5c = () => interopDefault(import('../pages/products/_category/_product/index.vue' /* webpackChunkName: "pages/products/_category/_product/index" */))
const _0eca4628 = () => interopDefault(import('../pages/_slug.vue' /* webpackChunkName: "pages/_slug" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/adatvedelmi-nyilatkozat",
    component: _225df9a5,
    name: "privacy-policy___hu___default"
  }, {
    path: "/bejelentkezes",
    component: _780dbd6a,
    name: "login___hu___default"
  }, {
    path: "/en",
    component: _0b5d0398,
    name: "index___en"
  }, {
    path: "/falikepek",
    component: _554ab386,
    name: "pictures___hu___default"
  }, {
    path: "/felhasznalo",
    component: _6dc178c8,
    name: "user___hu___default"
  }, {
    path: "/hu",
    component: _0b5d0398,
    name: "index___hu"
  }, {
    path: "/kapcsolat",
    component: _c5894ffc,
    name: "contact___hu___default"
  }, {
    path: "/karrier",
    component: _bfa42ee8,
    name: "career___hu___default"
  }, {
    path: "/magazin",
    component: _f6891db6,
    name: "magazine___hu___default"
  }, {
    path: "/regisztracio",
    component: _7d9b7872,
    name: "registration___hu___default"
  }, {
    path: "/rolunk",
    component: _4accb922,
    name: "about___hu___default"
  }, {
    path: "/szerkesztok",
    component: _3f66ce0b,
    name: "editors___hu___default"
  }, {
    path: "/termekek",
    component: _cbc2da16,
    name: "products___hu___default"
  }, {
    path: "/whispers-of-wood",
    component: _50b94d55,
    name: "whispers-of-wood___hu___default"
  }, {
    path: "/checkout/successful-order",
    component: _3154f766,
    name: "checkout-successful-order___hu___default"
  }, {
    path: "/en/about",
    component: _4accb922,
    name: "about___en"
  }, {
    path: "/en/career",
    component: _bfa42ee8,
    name: "career___en"
  }, {
    path: "/en/contact",
    component: _c5894ffc,
    name: "contact___en"
  }, {
    path: "/en/editors",
    component: _3f66ce0b,
    name: "editors___en"
  }, {
    path: "/en/login",
    component: _780dbd6a,
    name: "login___en"
  }, {
    path: "/en/magazine",
    component: _f6891db6,
    name: "magazine___en"
  }, {
    path: "/en/pictures",
    component: _554ab386,
    name: "pictures___en"
  }, {
    path: "/en/privacy-policy",
    component: _225df9a5,
    name: "privacy-policy___en"
  }, {
    path: "/en/products",
    component: _cbc2da16,
    name: "products___en"
  }, {
    path: "/en/registration",
    component: _7d9b7872,
    name: "registration___en"
  }, {
    path: "/en/user",
    component: _6dc178c8,
    name: "user___en"
  }, {
    path: "/en/whispers-of-wood",
    component: _50b94d55,
    name: "whispers-of-wood___en"
  }, {
    path: "/felhasznalo/kedvenc-termekek",
    component: _f2fe9ea4,
    name: "user-favourite-products___hu___default"
  }, {
    path: "/hu/adatvedelmi-nyilatkozat",
    component: _225df9a5,
    name: "privacy-policy___hu"
  }, {
    path: "/hu/bejelentkezes",
    component: _780dbd6a,
    name: "login___hu"
  }, {
    path: "/hu/falikepek",
    component: _554ab386,
    name: "pictures___hu"
  }, {
    path: "/hu/felhasznalo",
    component: _6dc178c8,
    name: "user___hu"
  }, {
    path: "/hu/kapcsolat",
    component: _c5894ffc,
    name: "contact___hu"
  }, {
    path: "/hu/karrier",
    component: _bfa42ee8,
    name: "career___hu"
  }, {
    path: "/hu/magazin",
    component: _f6891db6,
    name: "magazine___hu"
  }, {
    path: "/hu/regisztracio",
    component: _7d9b7872,
    name: "registration___hu"
  }, {
    path: "/hu/rolunk",
    component: _4accb922,
    name: "about___hu"
  }, {
    path: "/hu/szerkesztok",
    component: _3f66ce0b,
    name: "editors___hu"
  }, {
    path: "/hu/termekek",
    component: _cbc2da16,
    name: "products___hu"
  }, {
    path: "/hu/whispers-of-wood",
    component: _50b94d55,
    name: "whispers-of-wood___hu"
  }, {
    path: "/rendeles/fizetes-es-kiszallitas",
    component: _085871f1,
    name: "checkout-shipping-and-payment-details___hu___default"
  }, {
    path: "/rendeles/kosar",
    component: _56bc322b,
    name: "checkout-cart___hu___default"
  }, {
    path: "/rendeles/megrendeles-osszegzese",
    component: _bd716c2a,
    name: "checkout-summary___hu___default"
  }, {
    path: "/rendeles/szemelyes-adatok",
    component: _72b0df1c,
    name: "checkout-personal-data___hu___default"
  }, {
    path: "/szerkesztok/csillagterkep",
    component: _02ea6638,
    name: "editors-star-map___hu___default"
  }, {
    path: "/szerkesztok/domborzati-terkep",
    component: _94b63cc0,
    name: "editors-topo-map___hu___default"
  }, {
    path: "/szerkesztok/fa-csillagterkep",
    component: _1dea9b3a,
    name: "editors-wood-star-map___hu___default"
  }, {
    path: "/szerkesztok/fa-terkep",
    component: _797f9b93,
    name: "editors-wood-map___hu___default"
  }, {
    path: "/szerkesztok/terkep-szerkeszto",
    component: _017069d5,
    name: "editors-map___hu___default"
  }, {
    path: "/szerkesztok/varosi-epulet-terkep",
    component: _514ed051,
    name: "editors-city-map___hu___default"
  }, {
    path: "/en/checkout/checkout",
    component: _56bc322b,
    name: "checkout-cart___en"
  }, {
    path: "/en/checkout/personal-data",
    component: _72b0df1c,
    name: "checkout-personal-data___en"
  }, {
    path: "/en/checkout/shipping-and-payment-details",
    component: _085871f1,
    name: "checkout-shipping-and-payment-details___en"
  }, {
    path: "/en/checkout/successful-order",
    component: _3154f766,
    name: "checkout-successful-order___en"
  }, {
    path: "/en/checkout/summary",
    component: _bd716c2a,
    name: "checkout-summary___en"
  }, {
    path: "/en/editors/city-map-editor",
    component: _514ed051,
    name: "editors-city-map___en"
  }, {
    path: "/en/editors/map-editor",
    component: _017069d5,
    name: "editors-map___en"
  }, {
    path: "/en/editors/star-map-editor",
    component: _02ea6638,
    name: "editors-star-map___en"
  }, {
    path: "/en/editors/topo-map-editor",
    component: _94b63cc0,
    name: "editors-topo-map___en"
  }, {
    path: "/en/editors/wood-map-editor",
    component: _797f9b93,
    name: "editors-wood-map___en"
  }, {
    path: "/en/editors/wood-star-map-editor",
    component: _1dea9b3a,
    name: "editors-wood-star-map___en"
  }, {
    path: "/en/user/favourite-products",
    component: _f2fe9ea4,
    name: "user-favourite-products___en"
  }, {
    path: "/hu/checkout/successful-order",
    component: _3154f766,
    name: "checkout-successful-order___hu"
  }, {
    path: "/hu/felhasznalo/kedvenc-termekek",
    component: _f2fe9ea4,
    name: "user-favourite-products___hu"
  }, {
    path: "/hu/rendeles/fizetes-es-kiszallitas",
    component: _085871f1,
    name: "checkout-shipping-and-payment-details___hu"
  }, {
    path: "/hu/rendeles/kosar",
    component: _56bc322b,
    name: "checkout-cart___hu"
  }, {
    path: "/hu/rendeles/megrendeles-osszegzese",
    component: _bd716c2a,
    name: "checkout-summary___hu"
  }, {
    path: "/hu/rendeles/szemelyes-adatok",
    component: _72b0df1c,
    name: "checkout-personal-data___hu"
  }, {
    path: "/hu/szerkesztok/csillagterkep",
    component: _02ea6638,
    name: "editors-star-map___hu"
  }, {
    path: "/hu/szerkesztok/domborzati-terkep",
    component: _94b63cc0,
    name: "editors-topo-map___hu"
  }, {
    path: "/hu/szerkesztok/fa-csillagterkep",
    component: _1dea9b3a,
    name: "editors-wood-star-map___hu"
  }, {
    path: "/hu/szerkesztok/fa-terkep",
    component: _797f9b93,
    name: "editors-wood-map___hu"
  }, {
    path: "/hu/szerkesztok/terkep-szerkeszto",
    component: _017069d5,
    name: "editors-map___hu"
  }, {
    path: "/hu/szerkesztok/varosi-epulet-terkep",
    component: _514ed051,
    name: "editors-city-map___hu"
  }, {
    path: "/",
    component: _0b5d0398,
    name: "index___hu___default"
  }, {
    path: "/en/user/forgotten-password/:id",
    component: _494fe43f,
    name: "user-forgotten-password-id___en"
  }, {
    path: "/hu/felhasznalo/elfelejtett-jelszo/:id",
    component: _494fe43f,
    name: "user-forgotten-password-id___hu"
  }, {
    path: "/en/_failed-payment/:id",
    component: _0ffc069d,
    name: "payment-failed-id___en"
  }, {
    path: "/en/_successful-payment/:id",
    component: _b5a6cd0c,
    name: "payment-successful-id___en"
  }, {
    path: "/en/magazine/:article",
    component: _2bbc6634,
    name: "magazine-article___en"
  }, {
    path: "/en/order-failed/:id",
    component: _01211dd5,
    name: "order-failed-id___en"
  }, {
    path: "/en/order-feedback/:id",
    component: _09457ab6,
    name: "payment-feedback-id___en"
  }, {
    path: "/en/products/:category",
    component: _11a6c403,
    name: "products-category___en"
  }, {
    path: "/en/successful-order/:id",
    component: _79f9569c,
    name: "order-successful-id___en"
  }, {
    path: "/felhasznalo/elfelejtett-jelszo/:id",
    component: _494fe43f,
    name: "user-forgotten-password-id___hu___default"
  }, {
    path: "/hu/fizetes-visszaigazolas/:id",
    component: _09457ab6,
    name: "payment-feedback-id___hu"
  }, {
    path: "/hu/magazin/:article",
    component: _2bbc6634,
    name: "magazine-article___hu"
  }, {
    path: "/hu/sikeres-fizetes/:id",
    component: _b5a6cd0c,
    name: "payment-successful-id___hu"
  }, {
    path: "/hu/sikeres-rendeles/:id",
    component: _79f9569c,
    name: "order-successful-id___hu"
  }, {
    path: "/hu/sikertelen-fizetes/:id",
    component: _0ffc069d,
    name: "payment-failed-id___hu"
  }, {
    path: "/hu/sikertelen-rendeles/:id",
    component: _01211dd5,
    name: "order-failed-id___hu"
  }, {
    path: "/hu/termekek/:category",
    component: _11a6c403,
    name: "products-category___hu"
  }, {
    path: "/en/products/:category/:product",
    component: _2204cd5c,
    name: "products-category-product___en"
  }, {
    path: "/hu/termekek/:category/:product",
    component: _2204cd5c,
    name: "products-category-product___hu"
  }, {
    path: "/en/:slug",
    component: _0eca4628,
    name: "slug___en"
  }, {
    path: "/fizetes-visszaigazolas/:id",
    component: _09457ab6,
    name: "payment-feedback-id___hu___default"
  }, {
    path: "/hu/:slug",
    component: _0eca4628,
    name: "slug___hu"
  }, {
    path: "/magazin/:article",
    component: _2bbc6634,
    name: "magazine-article___hu___default"
  }, {
    path: "/sikeres-fizetes/:id",
    component: _b5a6cd0c,
    name: "payment-successful-id___hu___default"
  }, {
    path: "/sikeres-rendeles/:id",
    component: _79f9569c,
    name: "order-successful-id___hu___default"
  }, {
    path: "/sikertelen-fizetes/:id",
    component: _0ffc069d,
    name: "payment-failed-id___hu___default"
  }, {
    path: "/sikertelen-rendeles/:id",
    component: _01211dd5,
    name: "order-failed-id___hu___default"
  }, {
    path: "/termekek/:category",
    component: _11a6c403,
    name: "products-category___hu___default"
  }, {
    path: "/termekek/:category/:product",
    component: _2204cd5c,
    name: "products-category-product___hu___default"
  }, {
    path: "/:slug",
    component: _0eca4628,
    name: "slug___hu___default"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
